/* eslint-disable max-len */
const required = () => val => val && (val.length || val === +val);

const requiredWithZero = () => val => (val || val === 0) && (val.length || val === +val);

const minLength = min => val => val.length >= min;

const maxLength = max => val => val.length <= max;

const exactLength = length => val => val && val.length === length;

const lengthBetween = (min, max) => val => val.length >= min && val.length <= max;

const matches = exp => val => val.match(new RegExp(exp, 'gi'));

const isUrl = () => val => (val === '' || val === null) || (val.match(new RegExp(/^https?:\/\/[\w.-]+(?:.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/, 'gi')));

const isEmail = () => val => (val === undefined || val === '' || val === null) || (val.match(new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/, 'gi')));

const positive = () => val => val > 0;

const validatorFactory = (callback, field, validator, ...parameters) => (value) => {
  const valid = validator(...parameters)(value);
  if (callback) callback(field, valid ? null : 'error');
  return valid;
};

export const validators = {
  required: (callback, field) => validatorFactory(callback, field, required),
  requiredWithZero: (callback, field) => validatorFactory(callback, field, requiredWithZero),
  minLength: (length, callback, field) => validatorFactory(callback, field, minLength, length),
  maxLength: (length, callback, field) => validatorFactory(callback, field, maxLength, length),
  exactLength: (length, callback, field) => validatorFactory(callback, field, exactLength, length),
  lengthBetween: (min, max, callback, field) => validatorFactory(callback, field, lengthBetween, min, max),
  matches: (exp, callback, field) => validatorFactory(callback, field, matches, exp),
  isUrl: (callback, field) => validatorFactory(callback, field, isUrl),
  isEmail: (callback, field) => validatorFactory(callback, field, isEmail),
  isPositive: (callback, field) => validatorFactory(callback, field, positive),
};

export default validators;



// WEBPACK FOOTER //
// ./src/utils/validators.js